import type { Components, Theme } from '@mui/material';

export const theme: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    colorPrimary: {
      backgroundColor: '#01579B',
    },
    colorSecondary: {
      backgroundColor: '#00B5E2',
    },
    colorSuccess: {
      backgroundColor: '#008000',
    },
    colorInfo: {
      backgroundColor: '#558AE8',
    },
    colorWarning: {
      backgroundColor: '#F6C44A',
    },
    colorError: {
      backgroundColor: '#F14C2E',
    },
  },
};

export const muiChipThemeConfig = {
  MuiChip: {
    ...theme,
  },
};
